import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../lib/api';
import { useNotification } from '../../../shared/Notification/useNotification';

const useRemoveDependent = () => {
  const queryClient = useQueryClient();
  const { showSuccess, showError } = useNotification();

  return useMutation({
    mutationFn: () => api.delete('/api/account_settings/remove_dependent'),
    onSuccess: response => {
      if (response.data?.settings) {
        queryClient.setQueryData(['accountSettings'], response.data.settings);
      }
      showSuccess({
        title: 'Success',
        content: 'Dependent removed successfully!',
      });
    },
    onError: error => {
      showError({
        title: 'Error',
        content: error.response?.data?.errors || 'Failed to remove dependent',
      });
    },
  });
};

export default useRemoveDependent;
